import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly unprotectedRoutes: string[] = [
    '/auth/reset-password',
    '/auth/request-password',
    '/auth/logout',
    '/auth/otp/resend',
    '/auth/otp/verify',
    '/auth/register'
  ];

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let authReq = req;
    const token = localStorage.getItem("access_token");

    if (token && !req.headers.has('Authorization')) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
          }
      });
    } else if (environment.useCookies) { // Send request with cookies
      if (!req.withCredentials) {
        this.clearLocalSession();
      }

      authReq = req.clone({
          withCredentials: true
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        const currentUrl = this.router.url.split('?')[0];
        // const isUnprotected = this.unprotectedRoutes.some(route => currentUrl === route);
        const isUnprotected = this.unprotectedRoutes.some(route =>
          req.url.includes(route)
        );

        if (error.status === 401 && !isUnprotected) {
          localStorage.removeItem('currentUser'); // Remove the current User
          this.router.navigate(['auth/login']);
        }

        return throwError(error);
      })
    );
  }

  private clearLocalSession(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('auth_app_token');
  }
}
